import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useContext } from 'react';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Developer from './pages/Developer';
import SystemHealth from './pages/SystemHealth';
import Navbar from './Navbar';
import AuthWrapper, { UserContext } from './AuthWrapper';
import './App.css';

function RoutesWithAuth() {
  const { roles } = useContext(UserContext); // get roles from context

  return (
    <>
      <Navbar />
      <div style={{ padding: '2rem' }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route
            path="/admin"
            element={roles.includes('admin') ? <Admin /> : <p>Access denied</p>}
          />
          <Route
            path="/developer"
            element={roles.includes('developer') ? <Developer /> : <p>Access denied</p>}
          />
          <Route
            path="/health"
            element={roles.includes('developer') ? <SystemHealth /> : <p>Access denied</p>}
          />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthWrapper>
        <RoutesWithAuth />
      </AuthWrapper>
    </Router>
  );
}

export default App;
